import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import * as React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import { PageFooter } from 'components/PageFooter/PageFooter';
import { RootStore, withInjectedRootStore } from 'providers';
import s from './PlansPageFooter.scss';

const PlansPageFooterComp: React.FC<
  {
    rootStore: RootStore;
  } & InjectedExperimentsProps
> = ({ rootStore }) => {
  const { isEditorXSpecialDiscountEnabled, isDayful } = rootStore.appStore;
  const getFooterKey = () => {
    const { pricesIncludeTax } = rootStore.appStore;

    return pricesIncludeTax
      ? 'page_footer.plans_disclaimer_no_vat'
      : 'page_footer.plans_disclaimer_applicable_tax';
  };
  const { t } = useTranslation();

  const translationTags = {
    b: <b />,
    voucher: (
      <span
        data-hook='voucher-disclaimer'
        className={
          rootStore.appStore.isVoucherDisclaimerHidden
            ? s.hiddenLabel
            : s.visibleLabel
        }
      />
    ),
  };
  return (
    <PageFooter>
      {isEditorXSpecialDiscountEnabled && (
        <div>
          <Text
            weight='thin'
            size='tiny'
            dataHook='special-discount-disclaimer'
            secondary
          >
            {t('special_discount_disclaimer')}
          </Text>
        </div>
      )}
      <Text
        className={s.disclaimersText}
        weight='thin'
        size='tiny'
        dataHook='disclamer'
        secondary
      >
        <Trans i18nKey={getFooterKey()} components={translationTags} />
        {isDayful && (
          <>
            <br />
            <Trans i18nKey='page_footer.dayful.disclaimer_fees' />
            <br />
            <Trans i18nKey='page_footer.dayful.disclaimer_inapp_purchases' />
          </>
        )}
      </Text>
    </PageFooter>
  );
};

export const PlansPageFooter = withExperiments(
  withInjectedRootStore(PlansPageFooterComp),
);
